import { ToMoneyFormat } from "../../../../../utils/Helper";
import { breakWord, breakWord2 } from "../InvoiceGeneratorUtils";

const PDF_SUMMARY = (data: any) => {
  const print = (doc: any) => {
    // Variable
    const docWidth = doc.internal.pageSize.width;
    const docHeight = doc.internal.pageSize.height;
    const currentHeight = 15;

    const pdfConfig = {
      docWidth,
      docHeight,
      currentHeight,
    };

    // Total Saved
    doc.setFontSize(23);
    doc.text(170, pdfConfig.currentHeight, `Rp${data.savedTotal}`, {
      align: "center",
    });
    pdfConfig.currentHeight += 8;
    doc.setFontSize(11);
    doc.text(170, pdfConfig.currentHeight, "Saved this month", {
      align: "center",
    });

    // Total Expense
    pdfConfig.currentHeight += 10;
    doc.setFontSize(15);
    doc.text(5, pdfConfig.currentHeight, "Expense");
    doc.text(110, pdfConfig.currentHeight, "Income");
    pdfConfig.currentHeight += 6;
    doc.setFontSize(11);
    doc.text(5, pdfConfig.currentHeight, `Actual ${data.totalExpense}`);
    doc.text(110, pdfConfig.currentHeight, `Actual ${data.totalIncome}`);
    pdfConfig.currentHeight += 3;
    doc.line(docWidth / 2, pdfConfig.currentHeight, docWidth / 2, docHeight);
    doc.line(0, pdfConfig.currentHeight, docWidth, pdfConfig.currentHeight);
    pdfConfig.currentHeight += 10;

    doc.setFontSize(20);
    doc.text(5, pdfConfig.currentHeight, "Expense");
    doc.text(110, pdfConfig.currentHeight, "Income");

    doc.setFontSize(13);
    pdfConfig.currentHeight += 10;
    doc.text(5, pdfConfig.currentHeight, "Nama");
    doc.text(45, pdfConfig.currentHeight, "Actual");
    doc.text(75, pdfConfig.currentHeight, "Diff");

    doc.text(110, pdfConfig.currentHeight, "Nama");
    doc.text(150, pdfConfig.currentHeight, "Actual");
    doc.text(180, pdfConfig.currentHeight, "Diff");

    pdfConfig.currentHeight += 7;
    doc.setFontSize(9);
    pdfConfig.currentHeight = 70;

    // Expense
    data.expense.forEach((item: any) => {
      // const spaceCreate = breakWord(
      //   item.name,
      //   doc,
      //   pdfConfig.currentHeight,
      //   5,
      //   "none",
      //   10
      // );

      const spacingFromBreak = breakWord2({
        text: `${item.name}`,
        doc,
        maxWidth: 11,
        spacing: 4,
        x: 5,
        y: pdfConfig.currentHeight,
      });
      doc.text(45, pdfConfig.currentHeight, ToMoneyFormat(item.total));
      doc.text(75, pdfConfig.currentHeight, `${ToMoneyFormat(item.total)}`);
      pdfConfig.currentHeight += 4 + spacingFromBreak;
    });

    pdfConfig.currentHeight = 70;

    // Income
    data.income.forEach((item: any, index: number) => {
      const spacingFromBreak = breakWord2({
        text: `${item.name}`,
        doc,
        maxWidth: 11,
        spacing: 4,
        x: 110,
        y: pdfConfig.currentHeight,
      });
      doc.text(150, pdfConfig.currentHeight, ToMoneyFormat(item.total));
      doc.text(180, pdfConfig.currentHeight, `${ToMoneyFormat(item.total)}`);
      pdfConfig.currentHeight += 4 + spacingFromBreak;
    });
  };

  return { print };
};

export default PDF_SUMMARY;
